import { render, staticRenderFns } from "./recharge_old.vue?vue&type=template&id=f9442b80&scoped=true"
import script from "./recharge_old.vue?vue&type=script&lang=js"
export * from "./recharge_old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9442b80",
  null
  
)

export default component.exports